module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/products/products-performances/products-performances.component.scss
// module id = ./src/app/routes/products/products-performances/products-performances.component.scss
// module chunks = 9